import React, { Component } from 'react'
import RefSelect from './RefSelect';

import { getLocations } from '../api/resources/Locations'

export default class LocationSelect extends Component {

  constructor(props) {
    super(props)
    this.state = { locations: [] }
  }

  componentDidMount() {
    getLocations().then(locations => this.setState({ locations }) )
  }

  render() {

    const { initialValue, onUpdate, error } = this.props;
    const { locations } = this.state;

    return locations ?
      <RefSelect
        options={locations}
        initialValue={initialValue}
        onUpdate={onUpdate}
        error={error}
        label='Location'
      /> : null
    
  }
}